// src/pages/menopause/MenopausePages.jsx
// Routes:
//   /demo/menopause/myjourney  → MenopauseMyJourney
//   /demo/menopause/health     → MenopauseHealthRecord
//   /demo/menopause/community  → MenopauseCommunity
//   /demo/menopause/connect    → MenopauseConnect
//   /demo/menopause/events     → MenopauseEvents
//   /demo/menopause/products   → MenopauseProducts
//
// Add to App.js:
//   import { MenopauseMyJourney, MenopauseHealthRecord, MenopauseCommunity,
//            MenopauseConnect, MenopauseEvents, MenopauseProducts } from './pages/menopause/MenopausePages';
//
//   <Route path="/demo/menopause/myjourney" element={<MenopauseMyJourney />} />
//   <Route path="/demo/menopause/health"    element={<MenopauseHealthRecord />} />
//   <Route path="/demo/menopause/community" element={<MenopauseCommunity />} />
//   <Route path="/demo/menopause/connect"   element={<MenopauseConnect />} />
//   <Route path="/demo/menopause/events"    element={<MenopauseEvents />} />
//   <Route path="/demo/menopause/products"  element={<MenopauseProducts />} />

import { useState } from "react";
import NovaAvatarImg from "../../components/NovaAvatarImg";

// Menopause: --amber / --amber-l
const C = {
  primary: "var(--amber)", primaryL: "var(--amber-l)", primaryM: "var(--amber-m)", primaryDk: "var(--amber)",
  sand: "var(--sand)", sand2: "var(--sand-2)", white: "var(--card)", border: "var(--border)",
  muted: "var(--muted)", text: "var(--text)", text2: "var(--text-2)",
  sage: "var(--sage)", sageL: "var(--sage-l)", sageM: "var(--sage-m)", sageD: "var(--sage-d)",
  ppL: "var(--purple-l)", ppM: "var(--purple-m)", ppD: "var(--purple-d)",
  pinkL: "var(--pink-l)", pinkM: "var(--pink-m)", pinkDk: "var(--pink-dk)",
  r: "var(--r)",
};

const Card = ({children,style={}}) => <div style={{background:C.white,border:`1px solid ${C.border}`,borderRadius:C.r,padding:16,marginBottom:10,...style}}>{children}</div>;
const SLabel = ({children}) => <div style={{fontSize:10,fontWeight:700,letterSpacing:"0.1em",textTransform:"uppercase",color:C.muted,marginBottom:10}}>{children}</div>;
const Btn = ({children,variant="primary",style={},onClick}) => {
  const vs={primary:{background:C.primary,color:"#fff",border:"none"},ghost:{background:C.primaryL,color:C.primaryDk,border:`1px solid ${C.primaryM}`},sand:{background:C.sand,color:C.muted,border:`1px solid ${C.border}`}};
  return <button onClick={onClick} style={{fontFamily:"inherit",fontSize:12,fontWeight:700,borderRadius:999,padding:"7px 16px",cursor:"pointer",...vs[variant],...style}}>{children}</button>;
};
const Tag = ({children,bg=C.primaryL,color=C.primaryDk,border=C.primaryM}) => <span style={{fontSize:10,fontWeight:600,padding:"2px 9px",borderRadius:999,background:bg,color,border:`1px solid ${border}`,display:"inline-block"}}>{children}</span>;
const NovaBanner = ({text,prompts=[]}) => (
  <div style={{background:C.primaryL,border:`1px solid ${C.primaryM}`,borderRadius:C.r,padding:"12px 14px",display:"flex",gap:10,alignItems:"flex-start",marginBottom:14}}>
    <NovaAvatarImg size={28} alt="" />
    <div style={{flex:1}}>
      <div style={{fontSize:12,color:C.primaryDk,lineHeight:1.55,marginBottom:prompts.length?8:0}}>{text}</div>
      {prompts.length>0 && <div style={{display:"flex",gap:5,flexWrap:"wrap"}}>{prompts.map(p=><button key={p} style={{fontFamily:"inherit",fontSize:11,padding:"4px 10px",background:C.white,border:`1px solid ${C.primaryM}`,borderRadius:999,cursor:"pointer",color:C.primaryDk}}>{p}</button>)}</div>}
    </div>
    <button style={{fontFamily:"inherit",fontSize:11,fontWeight:600,color:C.primary,background:"none",border:"none",cursor:"pointer",whiteSpace:"nowrap"}}>Open Nova →</button>
  </div>
);

// ══════════════════════════════════════════════════════════════════════
// MENOPAUSE MY JOURNEY
// ══════════════════════════════════════════════════════════════════════
export function MenopauseMyJourney({ navigate }) {
  const nav = navigate || (() => {});
  const [tab,setTab]=useState("tracker");
  const [symptoms,setSymptoms]=useState([]);
  const SYMS=["Hot flash","Night sweats","Sleep disruption","Brain fog","Mood changes","Joint pain","Vaginal dryness","Low libido","Anxiety","Heart palpitations","Weight changes","Hair thinning","Fatigue","Headaches","Memory issues"];
  const toggleSym=s=>setSymptoms(p=>p.includes(s)?p.filter(x=>x!==s):[...p,s]);

  return (
    <div style={{fontFamily:"'Plus Jakarta Sans',-apple-system,sans-serif"}}>
      <div style={{padding:"0 0 24px"}}>
        <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:8,marginBottom:14}}>
          {[{label:"Days tracked",value:"14",sub:"Since Mar 9"},{label:"Symptoms logged",value:"3",sub:"Hot flash · Sleep · Mood"},{label:"HRT days",value:"—",sub:"Not started"}].map(s=>(
            <div key={s.label} style={{background:C.sand,borderRadius:C.r,padding:"12px 14px"}}>
              <div style={{fontSize:10,color:C.muted,marginBottom:4}}>{s.label}</div>
              <div style={{fontSize:22,fontWeight:700,color:C.text,letterSpacing:"-.02em"}}>{s.value}</div>
              <div style={{fontSize:10,color:C.muted,marginTop:2}}>{s.sub}</div>
            </div>
          ))}
        </div>

        <div style={{display:"flex",borderBottom:`1px solid ${C.border}`,marginBottom:14}}>
          {[["tracker","Today's log"],["patterns","My patterns"],["hrt","HRT tracker"],["doctor","Doctor prep"],["lifestyle","Lifestyle"]].map(([id,label])=>(
            <button key={id} onClick={()=>setTab(id)} style={{fontFamily:"inherit",fontSize:12,fontWeight:600,color:tab===id?C.primaryDk:C.muted,background:"none",border:"none",borderBottom:`2px solid ${tab===id?C.primary:"transparent"}`,padding:"10px 14px",cursor:"pointer",whiteSpace:"nowrap"}}>{label}</button>
          ))}
        </div>

        {tab==="tracker" && (
          <div>
            <Card>
              <SLabel>📝 Today's symptom log — Mar 23</SLabel>
              <div style={{marginBottom:14}}>
                <div style={{fontSize:12,fontWeight:600,color:C.text,marginBottom:8}}>What are you experiencing today?</div>
                <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                  {SYMS.map(s=>(
                    <button key={s} onClick={()=>toggleSym(s)} style={{fontSize:11,fontWeight:600,padding:"6px 12px",borderRadius:999,border:`1px solid ${symptoms.includes(s)?C.primaryM:C.border}`,background:symptoms.includes(s)?C.primaryL:C.sand,color:symptoms.includes(s)?C.primaryDk:C.muted,cursor:"pointer"}}>{s}</button>
                  ))}
                </div>
              </div>
              {symptoms.includes("Hot flash") && (
                <div style={{marginBottom:14}}>
                  <div style={{fontSize:12,fontWeight:600,color:C.text,marginBottom:8}}>Hot flash intensity</div>
                  <div style={{display:"flex",gap:6}}>
                    {["Mild — warm flush","Moderate — uncomfortable","Severe — soaking sweat","Night sweat — woke me up"].map(o=>(
                      <button key={o} style={{fontFamily:"inherit",fontSize:11,fontWeight:600,padding:"6px 12px",borderRadius:C.r,border:`1px solid ${C.border}`,background:C.sand,color:C.muted,cursor:"pointer"}}>{o}</button>
                    ))}
                  </div>
                </div>
              )}
              <div style={{marginBottom:14}}>
                <div style={{fontSize:12,fontWeight:600,color:C.text,marginBottom:8}}>Sleep quality last night</div>
                <div style={{display:"flex",gap:6}}>
                  {["😴 Great","🙂 OK","😐 Poor","😩 Terrible — up most of the night"].map(o=>(
                    <button key={o} style={{fontFamily:"inherit",fontSize:11,fontWeight:600,padding:"7px 13px",borderRadius:C.r,border:`1px solid ${C.border}`,background:C.sand,color:C.muted,cursor:"pointer"}}>{o}</button>
                  ))}
                </div>
              </div>
              <Btn variant="primary" style={{width:"100%",padding:"10px"}}>Save today's log</Btn>
            </Card>
          </div>
        )}

        {tab==="patterns" && (
          <div>
            <Card>
              <SLabel>Your symptom patterns — last 14 days</SLabel>
              <div style={{background:C.primaryL,borderRadius:C.r,padding:"12px 14px",marginBottom:14,fontSize:12,color:C.primaryDk,lineHeight:1.55}}>
                <strong>Nova noticed:</strong> Hot flashes peak 6–8pm (12 of 14 days). Sleep disruption on 9 of 14 days — correlates strongly with evening hot flashes. Mood changes logged on 6 of 14 days, mostly following poor sleep nights.
              </div>
              {[
                {label:"Hot flashes",count:12,of:14,bar:0.86,peak:"6–8 PM",color:C.primary},
                {label:"Night sweats / sleep disruption",count:9,of:14,bar:0.64,peak:"Early morning",color:"#E8602C"},
                {label:"Mood changes",count:6,of:14,bar:0.43,peak:"Morning after poor sleep",color:C.ppD},
                {label:"Brain fog",count:4,of:14,bar:0.29,peak:"Mid-morning",color:C.muted},
              ].map(s=>(
                <div key={s.label} style={{marginBottom:14}}>
                  <div style={{display:"flex",justifyContent:"space-between",marginBottom:5}}>
                    <span style={{fontSize:12,fontWeight:600,color:C.text}}>{s.label}</span>
                    <span style={{fontSize:11,color:C.muted}}>{s.count}/{s.of} days · peaks {s.peak}</span>
                  </div>
                  <div style={{height:8,background:C.sand2,borderRadius:999,overflow:"hidden"}}>
                    <div style={{width:`${s.bar*100}%`,height:"100%",background:s.color,borderRadius:999}}/>
                  </div>
                </div>
              ))}
              <Btn variant="ghost" style={{width:"100%"}}>Download symptom report for my doctor →</Btn>
            </Card>
          </div>
        )}

        {tab==="hrt" && (
          <div>
            <Card>
              <SLabel>HRT education — your options</SLabel>
              <div style={{background:C.primaryL,border:`1px solid ${C.primaryM}`,borderRadius:C.r,padding:"12px 14px",marginBottom:14,fontSize:12,color:C.primaryDk,lineHeight:1.6}}>
                <strong>Nova's note on HRT:</strong> HRT is the most effective treatment for hot flashes, sleep disruption, and vaginal symptoms. The old fears around breast cancer were based on outdated studies — current evidence shows HRT is safe for most women under 60 and within 10 years of menopause. Your symptoms and 14 days of data make a strong case to discuss this with Dr. Chang on April 8.
              </div>
              {[
                {type:"Estrogen-only (ET)",for:"Women without a uterus",form:"Patch, gel, spray, tablet",note:"Most effective for hot flashes. Lowest breast cancer risk of all types."},
                {type:"Combined HRT (EPT)",for:"Women with a uterus",form:"Patch, tablet, mirena IUS",note:"Estrogen + progesterone to protect the uterus. Tibolone also an option."},
                {type:"Local vaginal estrogen",for:"Vaginal dryness, painful sex, UTIs",form:"Cream, pessary, ring",note:"Very low systemic absorption. Can use alongside or instead of systemic HRT."},
                {type:"Testosterone",for:"Low libido",form:"Gel (off-label)",note:"Growing evidence for women's sexual health. Ask specifically — often under-prescribed."},
              ].map((h,i)=>(
                <div key={i} style={{padding:"12px 0",borderBottom:`1px solid ${C.sand2}`}}>
                  <div style={{fontSize:13,fontWeight:700,color:C.text,marginBottom:3}}>{h.type}</div>
                  <div style={{display:"flex",gap:8,marginBottom:5,flexWrap:"wrap"}}>
                    <Tag bg={C.sand2} color={C.muted} border={C.border}>{h.for}</Tag>
                    <Tag bg={C.ppL} color={C.ppD} border={C.ppM}>{h.form}</Tag>
                  </div>
                  <div style={{fontSize:12,color:C.text2,lineHeight:1.5}}>{h.note}</div>
                </div>
              ))}
              <Btn variant="primary" style={{marginTop:14,width:"100%"}}>Ask Nova to help me prepare for an HRT conversation →</Btn>
            </Card>
          </div>
        )}

        {tab==="doctor" && (
          <div>
            <Card>
              <div style={{display:"flex",justifyContent:"space-between",marginBottom:12}}>
                <SLabel style={{margin:0}}>Doctor appointment prep — April 8</SLabel>
                <Btn variant="ghost" style={{fontSize:11}}>Download report</Btn>
              </div>
              <div style={{background:C.primaryL,borderRadius:C.r,padding:"12px 14px",marginBottom:14,fontSize:12,color:C.primaryDk,lineHeight:1.6}}>
                Nova has built your symptom summary from 14 days of data. Here's what to bring and what to ask Dr. Chang.
              </div>
              <div style={{fontSize:12,fontWeight:700,color:C.text,marginBottom:8}}>Your symptom summary (to hand to your doctor)</div>
              <div style={{background:C.sand,borderRadius:C.r,padding:"12px 14px",marginBottom:14,fontSize:12,color:C.text2,lineHeight:1.7}}>
                Patient: Riley · Age 48 · Perimenopause (irregular cycles since Jan 2025)<br/>
                Logged symptoms (Mar 9–23):<br/>
                • Hot flashes: 12/14 days, severity 6–8/10, peak 6–8pm<br/>
                • Sleep disruption: 9/14 days, average 3 wake-ups/night<br/>
                • Mood changes (irritability, anxiety): 6/14 days<br/>
                • No vaginal symptoms logged to date<br/>
                Current treatment: None<br/>
                Patient question: Would like to discuss HRT options
              </div>
              <div style={{fontSize:12,fontWeight:700,color:C.text,marginBottom:8}}>Questions to ask</div>
              {["Am I a good candidate for HRT given my symptom pattern?","What type would you recommend — estrogen only or combined?","Is local vaginal estrogen an option I should add?","Can we discuss testosterone for energy and libido?","How long can I stay on HRT if it works?","What do I need to monitor while on HRT?"].map((q,i)=>(
                <div key={i} style={{display:"flex",gap:8,padding:"5px 0",fontSize:12,color:C.text2,alignItems:"baseline"}}>
                  <span style={{color:C.primary,fontWeight:700,flexShrink:0}}>·</span>{q}
                </div>
              ))}
            </Card>
          </div>
        )}

        {tab==="lifestyle" && (
          <div>
            <Card>
              <SLabel>Evidence-based lifestyle changes for menopause</SLabel>
              {[
                {icon:"🏋️",title:"Strength training",body:"Most impactful lifestyle intervention for menopause. Protects bone density, reduces hot flash frequency, improves sleep, and supports metabolism. 2–3x/week minimum."},
                {icon:"🌡️",title:"Hot flash triggers to track",body:"Alcohol, caffeine, spicy food, hot drinks, and stress are common triggers. Nova is tracking yours — after 30 days she can show you your personal trigger pattern."},
                {icon:"😴",title:"Sleep hygiene for menopause",body:"Keep bedroom cool (65–68°F). Moisture-wicking bedding. Avoid screens 1 hour before bed. Magnesium glycinate at night may help. Melatonin is less effective than in younger women."},
                {icon:"🧘",title:"Pelvic floor health",body:"Estrogen decline weakens pelvic floor. Pelvic PT is underused and highly effective — for incontinence, vaginal health, and sexual wellbeing. Ask your OB for a referral."},
                {icon:"🥦",title:"Bone health nutrition",body:"Calcium 1,200mg/day from food ideally. Vitamin D 2,000 IU. Protein 1.2g/kg for muscle preservation. Less alcohol, less salt (both deplete calcium)."},
              ].map((item,i)=>(
                <div key={i} style={{padding:"10px 0",borderBottom:`1px solid ${C.sand2}`}}>
                  <div style={{display:"flex",gap:10,alignItems:"flex-start"}}>
                    <span style={{fontSize:20,flexShrink:0}}>{item.icon}</span>
                    <div><div style={{fontSize:13,fontWeight:700,color:C.text,marginBottom:4}}>{item.title}</div><div style={{fontSize:12,color:C.text2,lineHeight:1.55}}>{item.body}</div></div>
                  </div>
                </div>
              ))}
            </Card>
          </div>
        )}

      </div>
    </div>
  );
}

// ══════════════════════════════════════════════════════════════════════
// MENOPAUSE HEALTH RECORD
// ══════════════════════════════════════════════════════════════════════
export function MenopauseHealthRecord({ navigate }) {
  const nav = navigate || (() => {});
  return (
    <div style={{fontFamily:"'Plus Jakarta Sans',-apple-system,sans-serif"}}>
      <div style={{padding:"0 0 24px"}}>
        <NovaBanner text="Based on 14 days of symptom data, Nova has built your symptom report for April 8. Your FSH and estradiol levels confirm perimenopause." prompts={["What does my FSH level mean?","Is my estradiol normal?","Build my doctor report"]} />

        <SLabel>Hormone panel</SLabel>
        <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:8,marginBottom:14}}>
          {[
            {label:"FSH",value:"38",sub:"mIU/mL · elevated",note:"Confirms perimenopause",color:C.primary},
            {label:"Estradiol",value:"48",sub:"pg/mL · low-normal",note:"Declining",color:C.primary},
            {label:"LH",value:"29",sub:"mIU/mL",note:"Elevated",color:C.primary},
            {label:"Thyroid (TSH)",value:"2.4",sub:"mIU/L · normal",note:"In range",color:C.text},
          ].map(s=>(
            <div key={s.label} style={{background:C.sand,borderRadius:C.r,padding:"12px 14px"}}>
              <div style={{fontSize:10,color:C.muted,marginBottom:3}}>{s.label}</div>
              <div style={{fontSize:16,fontWeight:700,color:s.color}}>{s.value}</div>
              <div style={{fontSize:10,color:C.muted,marginTop:2}}>{s.sub}</div>
              <span style={{fontSize:10,fontWeight:600,padding:"1px 7px",borderRadius:999,background:C.primaryL,color:C.primaryDk,border:`1px solid ${C.primaryM}`,marginTop:4,display:"inline-block"}}>{s.note}</span>
            </div>
          ))}
        </div>

        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:10}}>
          <Card>
            <SLabel>Symptom trend — 14 days</SLabel>
            {[
              {label:"Hot flashes",data:[3,4,3,5,6,4,5,7,6,5,8,7,6,7]},
              {label:"Sleep quality",data:[6,5,7,4,3,5,4,3,4,5,3,4,3,4]},
              {label:"Mood",data:[7,6,7,5,4,6,5,4,5,6,4,5,4,5]},
            ].map(metric=>(
              <div key={metric.label} style={{marginBottom:12}}>
                <div style={{fontSize:12,fontWeight:600,color:C.text,marginBottom:6}}>{metric.label}</div>
                <div style={{display:"flex",gap:2,alignItems:"flex-end",height:40}}>
                  {metric.data.map((v,i)=>(
                    <div key={i} style={{flex:1,background:C.primary,borderRadius:3,height:`${(v/10)*100}%`,opacity:0.3+v*0.07}}/>
                  ))}
                </div>
                <div style={{display:"flex",justifyContent:"space-between",fontSize:10,color:C.muted,marginTop:3}}>
                  <span>Mar 9</span><span>Mar 23</span>
                </div>
              </div>
            ))}
          </Card>
          <Card>
            <SLabel>Bone & heart health</SLabel>
            <div style={{background:C.primaryL,borderRadius:C.r,padding:"10px 12px",marginBottom:10,fontSize:12,color:C.primaryDk,lineHeight:1.5}}>
              Nova recommends discussing a DEXA bone density scan and cardiovascular risk baseline at your next appointment — both are affected by estrogen decline.
            </div>
            {[
              {test:"DEXA scan (bone density)",status:"Not yet ordered",recommend:"Recommended at menopause onset"},
              {test:"Cholesterol panel",status:"Due for review",recommend:"Estrogen affects lipid profile"},
              {test:"Blood pressure",status:"118/72 · normal",recommend:"Monitor annually"},
              {test:"Mammogram",status:"Up to date (2025)",recommend:"Annual from age 40"},
            ].map(t=>(
              <div key={t.test} style={{padding:"7px 0",borderBottom:`1px solid ${C.sand2}`,fontSize:12}}>
                <div style={{fontWeight:600,color:C.text}}>{t.test}</div>
                <div style={{color:C.muted,marginTop:1}}>{t.status} · {t.recommend}</div>
              </div>
            ))}
            <Btn variant="ghost" style={{marginTop:12,width:"100%"}}>Find a menopause specialist →</Btn>
          </Card>
        </div>
      </div>
    </div>
  );
}

// ══════════════════════════════════════════════════════════════════════
// MENOPAUSE COMMUNITY
// ══════════════════════════════════════════════════════════════════════
export function MenopauseCommunity({ navigate }) {
  const nav = navigate || (() => {});
  const POSTS=[
    {init:"R",bg:C.primaryM,color:C.primaryDk,name:"Riley",badge:"perimenopause",date:"3/23/2026",body:"14 days of tracking and Nova has already found my hot flash pattern — peaks at 6pm every day. I'm bringing this report to my OB next month and actually asking about HRT this time. 🌅",hearts:67,boats:41,replies:9},
    {init:"L",bg:C.ppM,color:C.ppD,name:"Linda T.",badge:null,date:"3/23/2026",body:"6 months on estrogen patch and I'm a different person. Sleep is back. Mood is stable. Hot flashes reduced by 80%. I wish I hadn't waited 2 years being told 'that's just menopause.' You deserve treatment.",hearts:312,boats:184,replies:44},
    {init:"J",bg:C.sageM,color:C.sageD,name:"Joyce M.",badge:"friend",date:"3/22/2026",body:"Anyone else dealing with anxiety that hit out of nowhere at 47? I've never been an anxious person and suddenly I wake up at 3am with my heart racing. Turns out this is perimenopause. Nobody told me.",hearts:189,boats:211,replies:38},
  ];
  return (
    <div style={{fontFamily:"'Plus Jakarta Sans',-apple-system,sans-serif"}}>
      <div style={{padding:"12px 16px 6px",background:C.sand,borderBottom:`1px solid ${C.border}`}}>
        <div style={{fontSize:10,fontWeight:700,letterSpacing:".1em",textTransform:"uppercase",color:C.muted,marginBottom:2}}>Community · Menopause</div>
        <div style={{fontSize:16,fontWeight:700,color:C.text,marginBottom:2}}>Your menopause community</div>
        <div style={{fontSize:12,color:C.muted,marginBottom:10}}>🌅 Menopause chapter — 6,800 members · 72 online right now</div>
      </div>
      <div style={{padding:14}}>
        <NovaBanner text="72 women online right now — the HRT Conversations room is the most active today. 18 women are comparing patch vs gel experiences." prompts={["Who else has anxiety as their main symptom?","What's the most active group for HRT?","Find women in perimenopause near me"]} />
        <div style={{background:C.white,border:`1px solid ${C.border}`,borderRadius:C.r,padding:"12px 14px",marginBottom:12}}>
          <div style={{display:"flex",gap:10}}>
            <div style={{width:36,height:36,borderRadius:"50%",background:C.primaryM,display:"flex",alignItems:"center",justifyContent:"center",fontSize:13,fontWeight:700,color:C.primaryDk}}>R</div>
            <input placeholder="Share something with your chapter..." style={{flex:1,fontFamily:"inherit",fontSize:13,border:`1px solid ${C.border}`,borderRadius:999,padding:"8px 14px",background:C.sand,color:C.muted}}/>
          </div>
          <div style={{display:"flex",justifyContent:"space-between",marginTop:10}}>
            <div style={{display:"flex",gap:6}}><Btn variant="sand" style={{fontSize:11,padding:"4px 12px"}}>📷 Photo</Btn></div>
            <div style={{display:"flex",gap:8,alignItems:"center"}}><Tag>🌅 Menopause</Tag><Btn variant="primary" style={{fontSize:12,padding:"6px 16px"}}>Post</Btn></div>
          </div>
        </div>
        {POSTS.map((post,i)=>(
          <div key={i} style={{background:C.white,border:`1px solid ${C.border}`,borderRadius:C.r,padding:"13px 15px",marginBottom:10}}>
            <div style={{display:"flex",gap:9,marginBottom:8}}>
              <div style={{width:36,height:36,borderRadius:"50%",background:post.bg,display:"flex",alignItems:"center",justifyContent:"center",fontSize:13,fontWeight:700,color:post.color,flexShrink:0}}>{post.init}</div>
              <div style={{flex:1}}>
                <div style={{fontSize:13,fontWeight:700,color:C.text}}>{post.name}{post.badge&&<span style={{fontSize:10,fontWeight:600,padding:"1px 7px",borderRadius:999,background:C.primaryL,color:C.primaryDk,border:`1px solid ${C.primaryM}`,marginLeft:6}}>{post.badge}</span>}</div>
                <div style={{fontSize:11,color:C.muted}}>{post.date}</div>
              </div>
            </div>
            <div style={{fontSize:13,color:C.text2,lineHeight:1.6,marginBottom:10}}>{post.body}</div>
            <div style={{display:"flex",borderTop:`1px solid ${C.sand2}`,paddingTop:7}}>
              <button style={{fontFamily:"inherit",fontSize:12,fontWeight:600,color:C.primary,background:"none",border:"none",flex:1,cursor:"pointer"}}>❤️ {post.hearts}</button>
              <button style={{fontFamily:"inherit",fontSize:12,fontWeight:600,color:C.primaryDk,background:"none",border:"none",flex:1,cursor:"pointer"}}>🤝 Same boat · {post.boats}</button>
              <button style={{fontFamily:"inherit",fontSize:12,fontWeight:600,color:C.muted,background:"none",border:"none",flex:1,cursor:"pointer"}}>💬 Reply · {post.replies}</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

// ══════════════════════════════════════════════════════════════════════
// MENOPAUSE CONNECT
// ══════════════════════════════════════════════════════════════════════
export function MenopauseConnect({ navigate }) {
  const nav = navigate || (() => {});
  const [tab,setTab]=useState("women");
  return (
    <div style={{fontFamily:"'Plus Jakarta Sans',-apple-system,sans-serif"}}>
      <div style={{display:"flex",borderBottom:`1px solid ${C.border}`}}>
        {[["women","💕 Women like me"],["rooms","🟢 Live rooms"],["groups","👥 Groups"]].map(([id,label])=>(
          <button key={id} onClick={()=>setTab(id)} style={{fontFamily:"inherit",fontSize:12,fontWeight:600,color:tab===id?C.primaryDk:C.muted,background:"none",border:"none",borderBottom:`2px solid ${tab===id?C.primary:"transparent"}`,padding:"11px 16px",cursor:"pointer",whiteSpace:"nowrap"}}>{label}</button>
        ))}
      </div>
      <div style={{padding:14}}>
        {tab==="women" && (
          <div>
            <div style={{background:C.primaryL,border:`1px solid ${C.primaryM}`,borderRadius:C.r,padding:"14px 16px",marginBottom:14}}>
              <div style={{fontSize:16,fontWeight:700,color:C.primaryDk,marginBottom:3}}>Women going through this with you</div>
              <div style={{fontSize:12,color:C.primaryDk}}>Matched on perimenopause stage · hot flash + sleep symptoms · Columbus, OH</div>
            </div>
            <div style={{fontSize:10,fontWeight:700,letterSpacing:".1em",textTransform:"uppercase",color:C.muted,marginBottom:10}}>Your closest match</div>
            <div style={{background:C.white,border:`2px solid ${C.primary}`,borderRadius:C.r,padding:16,marginBottom:10}}>
              <div style={{display:"flex",gap:10,marginBottom:8}}>
                <div style={{width:40,height:40,borderRadius:"50%",background:C.primaryM,display:"flex",alignItems:"center",justifyContent:"center",fontSize:13,fontWeight:700,color:C.primaryDk}}>JT</div>
                <div style={{flex:1}}><div style={{fontSize:13,fontWeight:700,color:C.text}}>Joan T.</div><div style={{fontSize:11,color:C.muted}}>Perimenopause · Age 47 · Hot flashes + sleep · Columbus</div></div>
                <span style={{fontSize:11,fontWeight:700,padding:"2px 8px",borderRadius:999,background:C.primaryL,color:C.primaryDk,border:`1px solid ${C.primaryM}`}}>94% match</span>
              </div>
              <div style={{display:"flex",gap:5,marginBottom:10,flexWrap:"wrap"}}>
                <Tag>Same stage</Tag>
                <Tag bg={C.ppL} color={C.ppD} border={C.ppM}>Same city</Tag>
                <Tag bg={C.sageL} color={C.sageD} border={C.sageM}>No HRT yet</Tag>
              </div>
              <div style={{fontStyle:"italic",fontSize:12,color:C.text2,background:C.sand,borderRadius:8,padding:"8px 12px",borderLeft:`3px solid ${C.primaryM}`,marginBottom:12}}>"Hot flashes started at 46, now I'm 47 and also losing sleep. I'm bringing 3 months of data to my OB and asking about HRT. Finally done with 'just deal with it.'"</div>
              <div style={{display:"flex",gap:8}}><Btn variant="primary" style={{flex:1}}>Connect</Btn><Btn variant="ghost" style={{flex:1}}>Message</Btn></div>
            </div>
          </div>
        )}
        {tab==="rooms" && (
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
            {[
              {name:"HRT conversations",desc:"Patch vs gel, doses, what worked",count:18,hot:true},
              {name:"Hot flash support",desc:"Triggers, cooling strategies, timing",count:12},
              {name:"Sleep & night sweats",desc:"Surviving broken sleep, what helps",count:9},
              {name:"Anxiety & mood shifts",desc:"When hormones meet mental health",count:14},
              {name:"Thriving at 50+",desc:"Energy, fitness, joy after menopause",count:7},
              {name:"Perimenopause — new here",desc:"Just started tracking, questions welcome",count:11},
            ].map(room=>(
              <div key={room.name} style={{background:room.hot?C.primaryL:C.white,border:`1px solid ${room.hot?C.primaryM:C.border}`,borderRadius:C.r,padding:"13px 14px"}}>
                {room.hot&&<span style={{fontSize:10,fontWeight:700,background:C.primary,color:"#fff",padding:"2px 7px",borderRadius:999,display:"inline-block",marginBottom:6}}>Active now</span>}
                <div style={{fontSize:13,fontWeight:700,color:room.hot?C.primaryDk:C.text,marginBottom:4}}>{room.name}</div>
                <div style={{fontSize:11,color:room.hot?C.primaryDk:C.muted,marginBottom:10,lineHeight:1.4}}>{room.desc}</div>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                  <div style={{display:"flex",alignItems:"center",gap:5,fontSize:11,fontWeight:600,color:C.primaryDk}}><div style={{width:6,height:6,borderRadius:"50%",background:"#22c55e"}}/>{room.count} online</div>
                  <Btn variant={room.hot?"primary":"sand"} style={{fontSize:11,padding:"4px 12px"}}>Join</Btn>
                </div>
              </div>
            ))}
          </div>
        )}
        {tab==="groups" && (
          <div>
            {[{icon:"🌅",name:"Peri Warriors",meta:"1,920 members · perimenopause, HRT, thriving",joined:true},{icon:"💛",name:"HRT Conversations",meta:"1,400 members · what actually works",joined:false},{icon:"🌟",name:"Thriving at 50+",meta:"2,200 members · life and joy after menopause",joined:false},{icon:"🧠",name:"Menopause & Mental Health",meta:"980 members · depression, anxiety, hormonal mood",joined:false}].map(g=>(
              <div key={g.name} style={{display:"flex",alignItems:"center",gap:10,padding:"11px 12px",background:C.white,border:`1px solid ${C.border}`,borderRadius:C.r,marginBottom:8}}>
                <div style={{width:38,height:38,borderRadius:10,background:C.primaryL,display:"flex",alignItems:"center",justifyContent:"center",fontSize:16}}>{g.icon}</div>
                <div style={{flex:1}}><div style={{fontSize:12,fontWeight:700,color:C.text}}>{g.name}</div><div style={{fontSize:11,color:C.muted}}>{g.meta}</div></div>
                {g.joined?<span style={{fontSize:10,fontWeight:600,padding:"2px 8px",borderRadius:999,background:C.primaryL,color:C.primaryDk,border:`1px solid ${C.primaryM}`}}>Joined</span>:<Btn variant="ghost" style={{fontSize:11,padding:"4px 12px"}}>Join →</Btn>}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

// ══════════════════════════════════════════════════════════════════════
// MENOPAUSE EVENTS
// ══════════════════════════════════════════════════════════════════════
export function MenopauseEvents({ navigate }) {
  const nav = navigate || (() => {});
  return (
    <div style={{fontFamily:"'Plus Jakarta Sans',-apple-system,sans-serif"}}>
      <div style={{padding:"0 0 24px"}}>
        <NovaBanner text="Nova found 4 menopause-relevant events near Columbus this month — including a free HRT information session on March 29 with Dr. Chang." prompts={["Find menopause specialists near me","Virtual HRT info sessions","Menopause fitness classes Columbus"]} />
        <div style={{display:"flex",gap:6,flexWrap:"wrap",marginBottom:14}}>
          {["All","In person","Virtual","This week","This month"].map(f=>(
            <button key={f} style={{fontFamily:"inherit",fontSize:11,fontWeight:600,padding:"5px 13px",borderRadius:999,border:`1px solid ${f==="All"?C.primaryM:C.border}`,background:f==="All"?C.primaryL:C.sand,color:f==="All"?C.primaryDk:C.muted,cursor:"pointer"}}>{f}</button>
          ))}
        </div>
        {[
          {date:"MAR\n29",title:"HRT Q&A — What You Were Never Told",org:"Dr. Linda Chang · Center for Women 40+ · Columbus",desc:"Free evening session. Dr. Chang covers HRT evidence, types, who's a candidate, what monitoring looks like. Q&A included. Nova matched you because of your April 8 appointment.",tags:["In person","Free","Nova matched"],hot:true},
          {date:"APR\n3", title:"Menopause & Mental Health Workshop",org:"Columbus Women's Wellness",desc:"How perimenopause affects anxiety, depression, and mood. Evidence-based coping strategies. Small group, confidential.",tags:["In person","$40","Mental health"]},
          {date:"APR\n10",title:"Strong After 40 — Strength Training for Menopause",org:"Ohio Functional Fitness",desc:"Monthly workshop for women in perimenopause and menopause. Evidence-based program for bone density and metabolism.",tags:["In person","$25","Fitness"]},
          {date:"APR\n16",title:"Pelvic Floor Health for Menopause",org:"Columbus PT · Virtual",desc:"Free virtual class. Pelvic floor PT explains what estrogen decline does and what can actually help — beyond kegels.",tags:["Virtual","Free","Pelvic health"]},
        ].map((ev,i)=>(
          <div key={i} style={{background:ev.hot?C.primaryL:C.white,border:`1px solid ${ev.hot?C.primaryM:C.border}`,borderRadius:C.r,padding:16,marginBottom:10,display:"flex",gap:14}}>
            <div style={{flexShrink:0,textAlign:"center",background:ev.hot?C.primary:C.sand,color:ev.hot?"#fff":C.text,borderRadius:10,padding:"8px 12px",minWidth:52}}>
              {ev.date.split("\n").map((l,j)=><div key={j} style={{fontSize:j===0?10:20,fontWeight:700,lineHeight:1.1}}>{l}</div>)}
            </div>
            <div style={{flex:1}}>
              <div style={{display:"flex",gap:5,flexWrap:"wrap",marginBottom:5}}>{ev.tags.map(t=><Tag key={t} bg={t==="Nova matched"?C.ppL:C.sand2} color={t==="Nova matched"?C.ppD:C.muted} border={t==="Nova matched"?C.ppM:C.border}>{t}</Tag>)}</div>
              <div style={{fontSize:13,fontWeight:700,color:ev.hot?C.primaryDk:C.text,marginBottom:3}}>{ev.title}</div>
              <div style={{fontSize:11,color:C.muted,marginBottom:6}}>{ev.org}</div>
              <div style={{fontSize:12,color:ev.hot?C.primaryDk:C.text2,lineHeight:1.5}}>{ev.desc}</div>
            </div>
            <Btn variant={ev.hot?"primary":"ghost"} style={{alignSelf:"flex-end",whiteSpace:"nowrap"}}>{ev.hot?"Register →":"Register"}</Btn>
          </div>
        ))}
      </div>
    </div>
  );
}

// ══════════════════════════════════════════════════════════════════════
// MENOPAUSE PRODUCTS
// ══════════════════════════════════════════════════════════════════════
export function MenopauseProducts({ navigate }) {
  const nav = navigate || (() => {});
  const [filter,setFilter]=useState("all");
  const PRODUCTS=[
    {brand:"Kindra",name:"Core Supplement — Menopause Relief",desc:"Ashwagandha + pycnogenol. Clinically studied for hot flashes. Non-hormonal. OB-recommended.",price:"$35",tag:"Supplements",tagType:"supplements",digs:1089,rating:4.7,reviews:"6.2k",featured:true},
    {brand:"Remi",name:"Sleep Cooling Eye Mask",desc:"Chilled gel that stays cold 20+ minutes. Night sweat recovery kit. Stays in fridge, slides on.",price:"$28",tag:"Sleep",tagType:"sleep",digs:876,rating:4.6,reviews:"4.1k"},
    {brand:"Replens",name:"Long-Lasting Vaginal Moisturiser",desc:"Non-hormonal. Use 3x/week for vaginal dryness independent of sex. OB-recommended, evidence-based.",price:"$22",tag:"Vaginal health",tagType:"vaginal",digs:742,rating:4.8,reviews:"9.8k"},
    {brand:"Embr Wave",name:"Embr Wave 2 — Wrist Cooling Device",desc:"On-demand wrist cooling that triggers the body's thermoregulation. Clinical trial data for hot flashes.",price:"$299",tag:"Hot flashes",tagType:"cooling",digs:634,rating:4.4,reviews:"2.8k"},
    {brand:"Magnesium Glycinate",name:"Magnesium Glycinate 400mg",desc:"Sleep, mood, and muscle cramp support. Magnesium glycinate is the best-absorbed form for sleep.",price:"$18",tag:"Supplements",tagType:"supplements",digs:521,rating:4.8,reviews:"14k"},
    {brand:"Menopause Taylor",name:"Menopause Taylor — Online Course",desc:"Dr. Barbie Taylor's comprehensive 7-hour course. The gold standard for understanding your options.",price:"$45",tag:"Education",tagType:"education",digs:489,rating:4.9,reviews:"3.4k"},
  ];
  const filtered=filter==="all"?PRODUCTS:PRODUCTS.filter(p=>p.tagType===filter);
  const tc={supplements:{bg:C.sageL,color:C.sageD,border:C.sageM},sleep:{bg:C.ppL,color:C.ppD,border:C.ppM},vaginal:{bg:C.pinkL,color:C.pinkDk,border:C.pinkM},cooling:{bg:C.primaryL,color:C.primaryDk,border:C.primaryM},education:{bg:"#FEF0EB",color:"#C94E22",border:"#f5c97a"}};

  return (
    <div style={{fontFamily:"'Plus Jakarta Sans',-apple-system,sans-serif"}}>
      <div style={{padding:"0 0 24px"}}>
        <NovaBanner text="Based on your hot flash and sleep disruption pattern, Nova recommends starting with magnesium glycinate for sleep and Kindra for daytime hot flash relief — both non-hormonal while you discuss HRT." prompts={["Is this supplement safe with HRT?","Best cooling products for hot flashes","Non-hormonal options for vaginal dryness"]} />
        <div style={{display:"flex",gap:6,alignItems:"center",marginBottom:14,flexWrap:"wrap"}}>
          <span style={{fontSize:10,fontWeight:700,letterSpacing:".08em",textTransform:"uppercase",color:C.muted,marginRight:4}}>Filter</span>
          {[["all","All"],["supplements","Supplements"],["sleep","Sleep"],["cooling","Hot flashes"],["vaginal","Vaginal health"],["education","Education"]].map(([id,label])=>(
            <button key={id} onClick={()=>setFilter(id)} style={{fontFamily:"inherit",fontSize:11,fontWeight:600,padding:"5px 14px",borderRadius:999,border:`1px solid ${filter===id?C.primaryM:C.border}`,background:filter===id?C.primaryL:C.sand,color:filter===id?C.primaryDk:C.muted,cursor:"pointer"}}>{label}</button>
          ))}
        </div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:10,marginBottom:14}}>
          {filtered.map(p=>{
            const colors=tc[p.tagType]||{bg:C.sand2,color:C.muted,border:C.border};
            return (
              <div key={p.name} style={{background:C.white,border:`${p.featured?"2px":"1px"} solid ${p.featured?C.primary:C.border}`,borderRadius:C.r,overflow:"hidden",display:"flex",flexDirection:"column",position:"relative"}}>
                {p.featured&&<div style={{position:"absolute",top:-1,left:14,background:C.primary,color:"#fff",fontSize:10,fontWeight:700,padding:"3px 10px",borderRadius:"0 0 8px 8px"}}>Nova's top pick</div>}
                <div style={{height:120,background:C.sand,display:"flex",alignItems:"center",justifyContent:"center",fontSize:32,position:"relative"}}>
                  🌅
                  <div style={{position:"absolute",top:10,left:10,background:"rgba(255,253,249,.92)",borderRadius:999,padding:"3px 8px",fontSize:10,fontWeight:700,color:C.text}}>★ {p.rating} <span style={{fontSize:10,color:C.muted}}>({p.reviews})</span></div>
                  <div style={{position:"absolute",bottom:8,right:8,background:C.primary,color:"#fff",fontSize:11,fontWeight:800,padding:"5px 11px",borderRadius:999}}>{p.digs} digs</div>
                </div>
                <div style={{padding:"12px 14px",flex:1,display:"flex",flexDirection:"column"}}>
                  <div style={{fontSize:10,fontWeight:700,letterSpacing:".1em",textTransform:"uppercase",color:C.muted,marginBottom:3}}>{p.brand}</div>
                  <div style={{fontSize:13,fontWeight:700,color:C.text,marginBottom:4}}>{p.name}</div>
                  <div style={{fontSize:11,color:C.muted,lineHeight:1.45,flex:1,marginBottom:10}}>{p.desc}</div>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                    <div style={{fontSize:16,fontWeight:700,color:C.text}}>{p.price}</div>
                    <span style={{fontSize:11,fontWeight:600,padding:"4px 10px",borderRadius:999,background:colors.bg,color:colors.color,border:`1px solid ${colors.border}`}}>{p.tag}</span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <div style={{background:C.primary,borderRadius:C.r,padding:"16px 20px",display:"flex",justifyContent:"space-between",alignItems:"center",gap:12}}>
          <div>
            <div style={{fontSize:13,fontWeight:600,color:"#fff"}}>Sign up to access the full menopause catalog</div>
            <div style={{fontSize:11,color:"rgba(255,255,255,0.8)",marginTop:2}}>150+ products — all reviewed for menopause safety and effectiveness</div>
          </div>
          <button style={{fontFamily:"inherit",fontSize:12,fontWeight:700,color:C.primaryDk,background:"#fff",border:"none",borderRadius:999,padding:"8px 18px",cursor:"pointer",whiteSpace:"nowrap"}}>Sign up free →</button>
        </div>
      </div>
    </div>
  );
}
